export const NOTICES = [
  { value: "MPr-2025-1", label: "MPr-2025-1 | I&D&I Empresarial" },
  {
    value: "MPr-2025-4",
    label: "MPr-2025-4 | I&D Empresarial - Operações Individuais ou em Copromoção",
  },
  {
    value: "COMPETE2030-2026-1",
    label:
      "COMPETE2030-2026-1 | STEP - I&D&I Empresarial - Energia - Operações em Copromoção",
  },
  {
    value: "MPr-2026-9",
    label:
      "MPr-2026-9 | STEP I&D&I Empresarial - Digital e Biotecnologia - Operações em Copromoção",
  },
  {
    value: "COMPETE2030-2026-11",
    label:
      "COMPETE2030-2026-11 | STEP I&D&I Empresarial - Energia - Operações em Copromoção",
  },
];

export const convertJsonData = (toConvert) => {
  if (Array.isArray(toConvert))
    return toConvert.map((v) => ({ _id: v.value, label: v.label }));

  return Object.entries(toConvert).reduce((acc, [k, arr]) => {
    acc[k] = arr.map((v) => ({ _id: v.value, label: v.label }));
    return acc;
  }, {});
};
